export const getValidRecurrentPosts = (posts, weekOldDate = null) => {
  const recurrentPosts = posts.filter((post) => {
    return !post.scheduled && !post.lastClonePostedTime && !post.time && post.isRecurrentPost;
  });

  const postsNotPostedByRecurrentPosts = posts.filter((post) => {
    return (
      post.scheduled &&
      !post.lastClonePostedTime &&
      post.time &&
      (!weekOldDate || post.time.toDate() < weekOldDate)
    );
  });

  const postsAlreadyPostedByRecurrentPosts = posts.filter((post) => {
    return (
      post.scheduled &&
      post.lastClonePostedTime &&
      (!weekOldDate || post.lastClonePostedTime.toDate() < weekOldDate)
    );
  });

  return [
    ...recurrentPosts,
    ...postsNotPostedByRecurrentPosts,
    ...postsAlreadyPostedByRecurrentPosts,
  ].filter((post) => !post.isRecurrentPostDisabled);
};
